import {useLazyQuery, useMutation} from '@apollo/client';
import {FilterType} from 'api/common';
import {tenantMutations} from 'api/graphql-queries';
import {tenantQueries} from 'api/graphql-queries/tenant/tenant.queries';
import {ResponseViewModel} from 'models';
import {SettingModel} from 'models/settings';
import {
    TanentUserRequestInput,
    TenantModel,
    TenantUserResponseModel,
    UserIdsForTenantRequestInput,
    UserListingResponseModel,
} from 'models/tenant.model';
import {useEffect, useState} from 'react';

export const useGetAllTenantsByUserId = () => {
    const [state, setState] = useState<TenantModel[]>([]);
    const [refetch, {data, loading}] = useLazyQuery<{allTenants: TenantModel[]}>(tenantQueries.ALL_TENANTS, {
        fetchPolicy: 'no-cache',
    });

    useEffect(() => {
        if (data) {
            setState(data.allTenants);
        }
    }, [data]);

    return {
        getAllTenants: refetch,
        allTenantsLoading: loading,
        allTenantsResponse: state,
    };
};

export const useUpdateTenantUserIsDefault = () => {
    const [refetch, {data, loading, error}] = useMutation<
        {updateTenantUserIsDefault: TenantUserResponseModel},
        {request: TanentUserRequestInput}
    >(tenantMutations.UPDATE_TENANT_USER_IS_DEFAULT, {
        fetchPolicy: 'no-cache',
    });

    return {
        updateUsersDefaultTenant: refetch,
        updateUserDefaultTenantLoading: loading,
        updateUserDefaultTenantResponse: data?.updateTenantUserIsDefault,
        updateUserDefaultTenantError: error,
    };
};

export const useGetUsersByTenantId = () => {
    const [getUsersByTenantId, {data, loading}] = useLazyQuery<
        {usersByTenantId: UserListingResponseModel[]},
        {tenantId: string}
    >(tenantQueries.USERS_BY_TENANT_ID, {
        fetchPolicy: 'no-cache',
    });

    return {
        getUsersByTenantId,
        getUsersByTenantIdLoading: loading,
        getUsersByTenantIdResponse: data?.usersByTenantId,
    };
};
export const useGetTenantSettings = () => {
    const [getTenanatSettings, {data, loading}] = useLazyQuery<
        {
            allTenantSettings: SettingModel[];
        },
        {
            controlType?: string;
            marketPlaceId?: string;
        }
    >(tenantQueries.GET_TENANT_SETTINGS, {
        fetchPolicy: 'no-cache',
    });

    return {
        getTenanatSettings,
        getTenanatSettingsLoading: loading,
        getTenanatSettingsRespones: data?.allTenantSettings,
    };
};

export const useGetUsersOfAllTenantsByUserId = () => {
    const [getUsersOfAllTenantsByUserId, {data, loading}] = useLazyQuery<
        {usersOfAllTenantsByUserId: UserListingResponseModel[]},
        {userId: string; where: FilterType<UserListingResponseModel>}
    >(tenantQueries.USERS_OF_ALL_TENANTS_BY_USER_ID, {
        fetchPolicy: 'no-cache',
    });

    return {
        getUsersOfAllTenantsByUserId,
        getUsersOfAllTenantsByUserIdLoading: loading,
        getUsersOfAllTenantsByUserIdResponse: data?.usersOfAllTenantsByUserId,
    };
};

export const useRemoveUsersFromTenant = () => {
    const [removeUsersFromTenant, {data, loading}] = useMutation<
        {removeUsersFromTenant: ResponseViewModel<string>},
        {request: UserIdsForTenantRequestInput}
    >(tenantMutations.REMOVE_USERS_FROM_TENANT, {
        fetchPolicy: 'no-cache',
    });

    return {
        removeUsersFromTenant,
        removeUsersFromTenantLoading: loading,
        removeUsersFromTenantResponse: data?.removeUsersFromTenant,
    };
};

export const useAddUsersToTenant = () => {
    const [addUsersToTenant, {data, loading}] = useMutation<
        {addUsersToTenant: ResponseViewModel<string>},
        {request: UserIdsForTenantRequestInput}
    >(tenantMutations.ADD_USERS_TO_TENANT, {
        fetchPolicy: 'no-cache',
    });

    return {
        addUsersToTenant,
        addUsersToTenantLoading: loading,
        addUsersToTenantResponse: data?.addUsersToTenant,
    };
};
